<template>
    <!--
        Timepicker component.
        Displays a timepicker overlay
    -->
    <div class="timepicker">
        <table class="table table-timepicker equal-padding">
            <tr>
                <td v-on:click="setHour('00')" v-on:dblclick="save" :class="['box-hour', (hour == '00') ? 'is-active' : '']">0</td>
                <td v-on:click="setHour('01')" v-on:dblclick="save" :class="['box-hour', (hour == '01') ? 'is-active' : '']">1</td>
                <td v-on:click="setHour('02')" v-on:dblclick="save" :class="['box-hour', (hour == '02') ? 'is-active' : '']">2</td>
                <td v-on:click="setHour('03')" v-on:dblclick="save" :class="['box-hour', (hour == '03') ? 'is-active' : '']">3</td>
                <td v-on:click="setHour('04')" v-on:dblclick="save" :class="['box-hour', (hour == '04') ? 'is-active' : '']">4</td>
                <td v-on:click="setHour('05')" v-on:dblclick="save" :class="['box-hour', (hour == '05') ? 'is-active' : '']">5</td>
                <td v-on:click="setMinute('00')" v-on:dblclick="save" :class="['box-minute', (minute == '00') ? 'is-active' : '']">00</td>
            </tr>
            <tr>
                <td v-on:click="setHour('06')" v-on:dblclick="save" :class="['box-hour', (hour == '06') ? 'is-active' : '']">6</td>
                <td v-on:click="setHour('07')" v-on:dblclick="save" :class="['box-hour', (hour == '07') ? 'is-active' : '']">7</td>
                <td v-on:click="setHour('08')" v-on:dblclick="save" :class="['box-hour', (hour == '08') ? 'is-active' : '']">8</td>
                <td v-on:click="setHour('09')" v-on:dblclick="save" :class="['box-hour', (hour == '09') ? 'is-active' : '']">9</td>
                <td v-on:click="setHour('10')" v-on:dblclick="save" :class="['box-hour', (hour == '10') ? 'is-active' : '']">10</td>
                <td v-on:click="setHour('11')" v-on:dblclick="save" :class="['box-hour', (hour == '11') ? 'is-active' : '']">11</td>
                <td v-on:click="setMinute('15')" v-on:dblclick="save" :class="['box-minute', (minute == '15') ? 'is-active' : '']">15</td>
            </tr>
            <tr>
                <td v-on:click="setHour('12')" v-on:dblclick="save" :class="['box-hour', (hour == '12') ? 'is-active' : '']">12</td>
                <td v-on:click="setHour('13')" v-on:dblclick="save" :class="['box-hour', (hour == '13') ? 'is-active' : '']">13</td>
                <td v-on:click="setHour('14')" v-on:dblclick="save" :class="['box-hour', (hour == '14') ? 'is-active' : '']">14</td>
                <td v-on:click="setHour('15')" v-on:dblclick="save" :class="['box-hour', (hour == '15') ? 'is-active' : '']">15</td>
                <td v-on:click="setHour('16')" v-on:dblclick="save" :class="['box-hour', (hour == '16') ? 'is-active' : '']">16</td>
                <td v-on:click="setHour('17')" v-on:dblclick="save" :class="['box-hour', (hour == '17') ? 'is-active' : '']">17</td>
                <td v-on:click="setMinute('30')" v-on:dblclick="save" :class="['box-minute', (minute == '30') ? 'is-active' : '']">30</td>
            </tr>
            <tr>
                <td v-on:click="setHour('18')" v-on:dblclick="save" :class="['box-hour', (hour == '18') ? 'is-active' : '']">18</td>
                <td v-on:click="setHour('19')" v-on:dblclick="save" :class="['box-hour', (hour == '19') ? 'is-active' : '']">19</td>
                <td v-on:click="setHour('20')" v-on:dblclick="save" :class="['box-hour', (hour == '20') ? 'is-active' : '']">20</td>
                <td v-on:click="setHour('21')" v-on:dblclick="save" :class="['box-hour', (hour == '21') ? 'is-active' : '']">21</td>
                <td v-on:click="setHour('22')" v-on:dblclick="save" :class="['box-hour', (hour == '22') ? 'is-active' : '']">22</td>
                <td v-on:click="setHour('23')" v-on:dblclick="save" :class="['box-hour', (hour == '23') ? 'is-active' : '']">23</td>
                <td v-on:click="setMinute('45')" v-on:dblclick="save" :class="['box-minute', (minute == '45') ? 'is-active' : '']">45</td>
            </tr>
            <tr class="box-buttons">
                <td colspan="2" v-on:click="remove"><icon name="close"/></td>
                <td colspan="3" class="box-time is-active">{{ time }}</td>
                <td colspan="2" v-on:click="save"><icon name="check" /></td>
            </tr>
        </table>
    </div>
</template>

<script>
import events from '../../events/events';

export default
{
    name: 'Timepicker',

    props: ['payload'],

    data() {
        return {
            hour: '--',
            minute: '--',
            loading: false
        }
    },

    computed:
    {
        time: function()
        {
            return this.hour + ':' + this.minute;
        },

        minutes: function()
        {
            return parseInt(this.hour, 10) * 60 + parseInt(this.minute, 10);
        },
    },

    created()
    {
        this.init();
    },

    watch:
    {
        payload()
        {
            this.init();
        }
    },

    methods:
    {
        init: function()
        {
            if (this.payload && this.payload.time)
            {
                this.setTime(this.payload.time);
            } else {
                this.reset();
            }
        },

        reset: function()
        {
            this.hour = this.minute = '--';
        },

        setTime: function(time)
        {
            time = time.split(':');

            this.setHour(time[0]);
            this.setMinute(time[1]);
        },

        setHour: function(hour)
        {
            this.hour = hour;

            if (this.minute == '--') this.minute = '00';
        },

        setMinute: function(minute)
        {
            this.minute = minute;

            if (this.hour == '--') this.hour = '08';
        },

        save: function()
        {
            if (this.time != '--:--')
            {
                this.loading = true;

                if (typeof this.payload.onSave == 'function')
                {
                    this.payload.onSave(this.time);
                }
                else
                {
                    this.close();
                }
            }
        },

        remove: function()
        {
            this.loading = true;

            if (typeof this.payload.onRemove == 'function')
            {
                this.payload.onRemove(this);
            }
            else
            {
                this.close();
            }
        },

        close: function()
        {
            this.loading = false;
        }
    },
}
</script>



// WEBPACK FOOTER //
// Timepicker.vue?354fab9c